import React from 'react';
import './Footer.css';
import {
  Email,
  Phone,
  LocationOn,
  AccessTime,
  Business
} from '@mui/icons-material';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const handleEmailClick = () => {
    window.location.href = 'mailto:KFoster98@proton.me';
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+12532242176'; // Update this with the new phone number
  };

  const openMaps = () => {
    const address = "Craft.19 Coffee Shop, Main Street, Sumner";
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>Businesses Grow<span> Together</span></h3>
              <p>Building connections that matter in business, mindset, and knowledge.</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Contact Information</h3>
            <div className="contact-info">
              <div 
                className="contact-item" 
                onClick={handlePhoneClick}
                style={{cursor: 'pointer'}}
              >
                <Phone className="contact-icon" />
                <div className="contact-text">
                  <span className="contact-label">Phone</span>
                  <span className="contact-value">425-358-1266</span> {/* Update this with the new phone number */}
                </div>
              </div>
              
              <div 
                className="contact-item" 
                onClick={handleEmailClick}
                style={{cursor: 'pointer'}}
              >
                <Email className="contact-icon" />
                <div className="contact-text">
                  <span className="contact-label">Email</span>
                  <span className="contact-value">KFoster98@proton.me</span>
                </div>
              </div>
              
              <div 
                className="contact-item" 
                onClick={openMaps}
                style={{cursor: 'pointer'}}
              >
                <LocationOn className="contact-icon" />
                <div className="contact-text">
                  <span className="contact-label">Meeting Venue</span>
                  <span className="contact-value">Craft.19 Coffee Shop, Main Street, Sumner</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Meeting Schedule</h3>
            <div className="meeting-info">
              <div className="meeting-item">
                <AccessTime className="meeting-icon" />
                <div className="meeting-text">
                  <span className="meeting-day">Every Wednesday</span>
                  <span className="meeting-time">8:00 AM</span>
                </div>
              </div>
              <div className="meeting-item">
                <Business className="meeting-icon" />
                <div className="meeting-text">
                  <span className="meeting-venue-type">Coffee Shop Setting</span>
                  <span className="meeting-duration">Casual 1-1.5 Hours</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>© {currentYear} Businesses Grow Together Networking Group. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;